export default __webpack_public_path__ + "static/media/icn_login_password.665298c2.svg";